
import BaseService from './BaseService'

class SocialMediaService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  allowedLocations = (id: string) => this.requests.get(`/${id}/users`)
}

const instance = new SocialMediaService(BaseService.servicesConfig.SocialMediaService)

export default instance